import { api } from "@/features/utils/fetch-server";
import type {
  BookingAccountSave,
  BookingAccountUsage,
  CheckedIntegration,
  IntegrationCheck,
} from "../types";

export class IntegrationsAPI {
  /** Try an account with the provider before it is saved. */
  static check = async (
    clientId: string,
    integration: CheckedIntegration,
    configuration: Record<string, unknown>,
  ): Promise<IntegrationCheck> =>
    api.post(
      `/api/calendars/v1/${clientId}/booking/integrations/${integration}/check`,
      { configuration },
    );

  /**
   * Check a booking account with its provider and keep it if it said yes —
   * a new one, or `accountId` updated. `unchecked` keeps it when the provider
   * did not answer at all.
   */
  static saveBookingAccount = async (
    clientId: string,
    body: {
      integration: CheckedIntegration;
      configuration: Record<string, unknown>;
      unchecked?: boolean;
    },
    accountId?: string,
  ): Promise<BookingAccountSave> =>
    accountId
      ? api.put(
          `/api/calendars/v1/${clientId}/booking/accounts/${accountId}`,
          body,
        )
      : api.post(`/api/calendars/v1/${clientId}/booking/accounts`, body);

  static bookingAccountUsage = async (
    clientId: string,
  ): Promise<BookingAccountUsage> =>
    (
      await api.get<{ usage: BookingAccountUsage }>(
        `/api/calendars/v1/${clientId}/booking/accounts/usage`,
      )
    ).usage;
}
